import { JSX } from 'react';
import type { WithContext } from 'schema-dts';

import type { NonStringThing } from '@videoblocks/structured-data';

const StructuredData = ({ data }: { data: NonStringThing }): JSX.Element => {
    const structuredData: WithContext<NonStringThing> = {
        '@context': 'https://schema.org',
        ...data,
    };
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }} />;
};

export default StructuredData;
